(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halvea-selection"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root) => {
    root.querySelectorAll('.hs-selection').forEach((selection) => {
      if (selection.dataset.initialized) return;
      selection.dataset.initialized = 'true';
      const filters = [...selection.querySelectorAll('.hs-filter')];
      filters.forEach((filter) => filter.addEventListener('toggle', () => {
        if (filter.open) filters.forEach((other) => { if (other !== filter) other.open = false; });
      }));
      selection.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const open = filters.find((filter) => filter.open);
          if (open) { open.open = false; open.querySelector('summary').focus(); }
        }
      });
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.hs-filter')) filters.forEach((filter) => { filter.open = false; });
      });
      const sort = selection.querySelector('.hs-sort select');
      sort?.addEventListener('change', () => sort.form.requestSubmit());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
